export { ModuleFooter, type ModuleFooterProps } from './ModuleFooter';
